import $ from 'jquery';
import { GondelJqueryComponent } from '@gondel/plugin-jquery';
import { PlayerEventCallbackFn } from './video';
import { EventNames } from '@swisslife/shared-ui/src/utils/custom-event/js/custom-event';

export interface IInitXtendxReturn {
	markup: string;
	remove: () => void;
	addEventCallback: (callbackFn) => void;
}

interface IPostMessageData {
	title?: string;
	ID?: string;
	play?: 'on' | 'off';
	progress?: 'Start' | 'Complete' | '25%' | '50%' | '75%';
}

export const initXtendx = (videoContext: GondelJqueryComponent) => {
	const playerCallbacks: PlayerEventCallbackFn[] = [];
	const {
		srcUrl,
		srcCustomerid,
		srcAuthorid,
		srcProjectid,
		srcAutostart,
		srcMutevideo,
		srcSendevents,
	} = videoContext.$ctx.data();
	const videoID = `/${srcCustomerid}/${srcAuthorid}/${srcProjectid}`;
	const iframeId = srcProjectid.toString();
	let videoTitle: string;
	let progress: 0 | 25 | 50 | 75 | 100 = 0;

	const handleMessage = (messageEvent: MessageEvent) => {
		if (typeof messageEvent.data !== 'string') {
			return;
		}
		// escape single quotes
		let jsonString: string = messageEvent.data.replace(/'/g, '&quot;');
		// remove 'simplex'
		jsonString = jsonString.replace(/simplex./gi, '');
		// handle parse exception
		try {
			const data: IPostMessageData = JSON.parse(jsonString);
			// ignore other videos' events by matching iframeId and event id
			switch (data.play || data.progress) {
				case 'Start': {
					videoTitle = data.title || 'no video-title';
					if (iframeId === data.ID) {
						triggerCustomEvent(EventNames.VideoPlay);
					}
					break;
				}
				case 'off': {
					if (iframeId === data.ID) {
						triggerCustomEvent(EventNames.VideoStop);
					}
					break;
				}
				case '25%':
				case '50%':
				case '75%': {
					if (iframeId === data.ID) {
						handleProgressEvents(data);
					}
					break;
				}
				case 'Complete': {
					if (iframeId === data.ID) {
						triggerCustomEvent(EventNames.VideoComplete);
					}
					progress = 0;
					break;
				}
			}
		} catch (error) {
			// tslint:disable-next-line: no-console
			console.warn('Received invalid JSON string from simplex event data: ', error);
		}
	};

	// if a user skips to a certain point in the video, we might need to fire multiple events
	const handleProgressEvents = (data: IPostMessageData) => {
		if (progress === 0) {
			progress = 25;
			triggerCustomEvent(EventNames.VideoProgress, true);
		}
		if (progress === 25 && (data.progress === '50%' || data.progress === '75%')) {
			progress = 50;
			triggerCustomEvent(EventNames.VideoProgress, true);
		}
		if (progress === 50 && data.progress === '75%') {
			progress = 75;
			triggerCustomEvent(EventNames.VideoProgress, true);
		}
	};

	const triggerCustomEvent = (eventName: EventNames, includeProgress: boolean = false) => {
		playerCallbacks.forEach((playerCallback) => {
			playerCallback('xtendx', eventName, videoID, videoTitle, includeProgress ? progress : undefined);
		});
	};

	(window as any).addEventListener('message', handleMessage, false);

	const createIframe = () => {
		const { frameborder, fullscreen, type, scrolling, iframeid } = videoContext.$ctx.data();
		const markup = `<iframe
					id="${iframeid}"
					src="${createUrl()}"
					type="${type}"
					frameborder="${frameborder}"
					allowfullscreen="${fullscreen}"
					webkitallowfullscreen="${fullscreen}"
					mozallowfullscreen="${fullscreen}"
					scrolling="${scrolling}"
					width="100%"
				>
				</iframe>`;

		return {
			markup,
			remove: () => {
				$(`#${videoContext.$ctx.data('iframeid')}`).remove();
			},
			addEventCallback: (callbackFn) => {
				playerCallbacks.push(callbackFn);
			},
		};
	};

	const createUrl = () => {
		return `${srcUrl}?embed=1&cID=${srcCustomerid}&aID=${srcAuthorid}&pID=${srcProjectid}
				&autostart=${srcAutostart}&muteVideo=${srcMutevideo}&sendEvents=${srcSendevents}`;
	};

	return createIframe();
};
